import { Box, Text } from "@chakra-ui/react";
import { FaGithubAlt, FaMastodon, FaFrog, FaEnvelope } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import Colors from "../Utils/Colors";
import { Contact, Urls } from "../Utils/Strings";
import Font from "../Utils/Calligraphy";
import { useState } from "react";

const ContactBox = () => {
  const [isFrogHovered, setIsFrogHovered] = useState(false);
  const [isMailHovered, setIsMailHovered] = useState(false);
  const [isGitHubHovered, setIsGitHubHovered] = useState(false);
  const [isMastodonHovered, setIsMastodonHovered] = useState(false);

  const playSoundEffect = async () => {
    try {
      const randomCoinEffectNumber = Math.floor(Math.random() * 3) + 1;
      const audio = new Audio(`/audio/coin${randomCoinEffectNumber}.wav`);
      audio.volume = 0.3;
      await audio.play();
    } catch (error) {
      console.error("Failed to play audio:", error);
    }
  };

  const openContactForm = async () => {
    try {
      const audio = new Audio(`/audio/power_up.wav`);
      audio.volume = 0.3;
      await audio.play();
      window.location.href = `mailto:${Contact.Email}`;
      console.log("clicked! mailto");
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };

  const handleFrogClick = () => {
    playSoundEffect();
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      marginBottom="2rem"
    >
      <Text fontFamily={Font.Bold} fontSize={22}>
        Contact
      </Text>
      <Box h={"1rem"} />
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box as={motion.div} whileHover={{ scale: 1.1 }}
                  onMouseEnter={() => setIsGitHubHovered(true)}
                  onMouseLeave={() => setIsGitHubHovered(false)}
        >
          <Link to={Urls.Github} target="_blank" rel="noopener noreferrer">
            <FaGithubAlt
              color={Colors.Text}
              size={24}
              style={
                isGitHubHovered
                  ? { color: Colors.GitHub }
                  : { color: Colors.Text }
              }
            />
          </Link>
        </Box>
        <Box w="2vw" />
        <Box
          as={motion.div}
          whileHover={{ scale: 1.1 }}
          onMouseEnter={() => setIsMastodonHovered(true)}
          onMouseLeave={() => setIsMastodonHovered(false)}
        >
          <Link to={Urls.Mastodon} target="_blank" rel="noopener noreferrer">
            <FaMastodon
              color={Colors.Text}
              size={24}
              style={
                isMastodonHovered
                  ? { color: Colors.Mastodon }
                  : { color: Colors.Text }
              }
            />
          </Link>
        </Box>
        <Box w="2vw" />
        <Box
          as={motion.div}
          whileHover={{ scale: 1.1 }}
          onClick={openContactForm}
          onMouseEnter={() => setIsMailHovered(true)}
          onMouseLeave={() => setIsMailHovered(false)}
        >
          <FaEnvelope
            color={Colors.Text}
            size={24}
            style={
              isMailHovered ? { color: Colors.Mail } : { color: Colors.Text }
            }
          />
        </Box>
        <Box w="2vw" />
        <Box
          as={motion.div}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.8 }}
          onClick={handleFrogClick}
          color={isFrogHovered ? "coral" : "inherit"}
          onMouseEnter={() => setIsFrogHovered(true)}
          onMouseLeave={() => setIsFrogHovered(false)}
        >
          <FaFrog
            color={Colors.Text}
            size={24}
            style={
              isFrogHovered ? { color: Colors.Frog } : { color: Colors.Text }
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ContactBox;
